// extracted by mini-css-extract-plugin
export default {"package-name":"O1E5rCTXSIJuOdEqsDQ1","name":"dYhF6UvvwwTF99xUf7R0"};